import CardsWrapper from "../../cardsWrapper";
import {HotelCardView} from "../hotelCardView/hotelCard.view";
import {FC} from "react";
import {HotelCardProps} from "../hotelCard.types";
import {useRoomNavigation} from "../../hooks/useRoomNavigation";

export const HotelCardController: FC<HotelCardProps> = ({room, index}) => {
    const { openCopiaHandler } = useRoomNavigation(room, () => {});

    return (
        <CardsWrapper image={room.logo} action={openCopiaHandler} room={room}>
            <HotelCardView room={room} index={index}/>
        </CardsWrapper>
    )
}
